<template>
  <div class="wrapper wrapper-footer border-top pt-5">
    <div class="container footer">
      <div class="row">
        <div class="col-12 col-md-3">
          <p><img src="/static/images/logo_dark.svg" alt="" width="94"></p>
          <p>
            <a href="#"><i class="fa fa-instagram fa-2x"></i></a>
            <a href="#"><i class="fa fa-facebook fa-2x mx-3"></i></a>
            <a href="#"><i class="fa fa-youtube fa-2x"></i></a>
          </p>
          <p>© 2021 <a href="https://izuchai.com/">Изучай</a></p>
        </div>
        <div class="col-4 col-md-2">
          <h3>Ученикам</h3>
          <ul>
            <li>
              <a href="https://izuchai.com/teachers/">Учителя</a>
            </li>
            <li>
              <a href="https://izuchai.com/subjects/">Предметы</a>
            </li>
            <li>
              <a href="https://izuchai.com/price/">Стоимость</a>
            </li>
          </ul>
        </div>
        <div class="col-4 col-md-2">
          <h3>Учителям</h3>
          <ul>
            <li>
              <a href="https://izuchai.com/#">Работа в Изучай</a>
            </li>
            <li>
              <a href="#">Поддержка</a>
            </li>
          </ul>        
        </div>
        <div class="col-4 col-md-2">
          <h3>Помощь</h3>
          <ul>
            <li>
              <a href="https://izuchai.com/faq/">FAQ</a>
            </li>
            <li>
              <a href="https://izuchai.com/news/">Новости</a>
            </li>
            <li>
              <a href="https://izuchai.com/terms/">Соглашение</a>
            </li>
            <li>
              <a href="https://izuchai.com/agreement/">Обработка данных</a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-3">
          <h3>Контакты</h3>
          <!-- <p>Москва, ул. Зои Космодемьянской 15, д. 16, офис “Изучай”</p>
          <p>+7 (965) 441-23-13 <span class="text-muted">— 10:00–20:00</span></p> -->
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <footer class="pt-4 my-md-3 pt-md-1">
            <div class="row">
              <div class="col-md-12">
                <p class="text-center mb-1">
                  <small class="d-block text-muted"><a href="https://izuchai.com/">Izuchai.com</a> – удобная онлайн-школа для всех</small>
                </p>
              </div>
            </div>
          </footer>

        </div><!--col end -->

      </div><!-- row end -->

    </div><!-- container end -->

  </div><!-- wrapper end -->

</template>

<script>
export default {
  name: 'app-footer',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  computed: {
  },
  created () {
  }
}
</script>